/**
 * Shokz theme — central YouTube IFrame API loader.
 * - Injects iframe_api at most once; chains window.onYouTubeIframeAPIReady when we inject.
 * - Polls for YT.Player so callbacks still run if another script overwrites onYouTubeIframeAPIReady.
 * - New code: ShokzYouTubeIframe.ready(function (YT) { new YT.Player(...); });
 * - Pandectes / CMP: ShokzYouTubeIframe.promoteYoutubeIframeSrc(containerElement) on user open.
 */
(function (window, document) {
  var queue = [];
  var MAX_POLLS = 300;
  var pollCount = 0;

  function flushQueue() {
    if (!window.YT || !window.YT.Player) return;
    var pending = queue.slice();
    queue.length = 0;
    for (var i = 0; i < pending.length; i++) {
      try {
        pending[i](window.YT);
      } catch (e) {
        if (window.console && console.error) console.error(e);
      }
    }
  }

  function poll() {
    flushQueue();
    if (window.YT && window.YT.Player) return;
    if (pollCount++ < MAX_POLLS) {
      window.setTimeout(poll, 50);
    }
  }

  function ensureScript() {
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      poll();
      return;
    }
    var previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof previous === "function") {
        try {
          previous();
        } catch (e) {
          if (window.console && console.error) console.error(e);
        }
      }
      flushQueue();
    };
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(tag, firstScript);
    poll();
  }

  function ready(fn) {
    if (typeof fn !== "function") return;
    if (window.YT && window.YT.Player) {
      try {
        fn(window.YT);
      } catch (e) {
        if (window.console && console.error) console.error(e);
      }
      return;
    }
    queue.push(fn);
    flushQueue();
  }

  function promoteYoutubeIframeSrc(root) {
    var el = root || document;
    if (!el || !el.querySelectorAll) return;
    var iframes = el.querySelectorAll("iframe[data-src]");
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      var dataSrc = iframe.getAttribute("data-src");
      if (!dataSrc) continue;
      if (
        dataSrc.indexOf("youtube.com") === -1 &&
        dataSrc.indexOf("youtu.be") === -1
      )
        continue;
      var src = iframe.getAttribute("src") || "";
      if (
        !src ||
        src === "about:blank" ||
        src.indexOf("youtube.com") === -1
      ) {
        iframe.setAttribute("src", dataSrc.replace(/&amp;/g, "&"));
      }
    }
  }

  window.ShokzYouTubeIframe = {
    ready: ready,
    ensureScript: ensureScript,
    promoteYoutubeIframeSrc: promoteYoutubeIframeSrc,
  };

  ensureScript();
  poll();
})(window, document);
